import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const QuestionEyebrow = styled(Typography)({
  fontSize: '11px',
  fontWeight: 700,
  color: 'var(--am-accent-text)',
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  marginBottom: 10,
}) as typeof Typography;

export const QuestionTitle = styled(Typography)({
  fontSize: '22px',
  fontWeight: 700,
  color: 'var(--am-text-primary)',
  margin: 0,
  lineHeight: 1.25,
}) as typeof Typography;

export const QuestionHelper = styled(Typography)({
  fontSize: '14px',
  color: 'var(--am-text-secondary)',
  marginTop: 8,
  lineHeight: 1.5,
}) as typeof Typography;

export const QuestionBodyBox = styled(Box)({
  marginTop: 20,
});
